import React from "react";
import { Navigate, Outlet, PathRouteProps } from "react-router-dom";
import { useAuth } from "@context/auth-context";
import { UserType } from "@models/User";

interface ProtectedRouteProps extends Omit<PathRouteProps, "element"> {
    allowedRoles: UserType[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
    const { authState } = useAuth();
    const { user } = authState;

    if (!user || !allowedRoles.includes(user.userType)) {
        return <Navigate to="/unauthorised" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
